import React from 'react';

const ProfileSkeleton = ({
    className = "",
    showImage = true,
    showButton = true,
    fieldCount = 8
}) => {
    const shimmerStyle = {
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2.5s infinite',
        borderRadius: '4px'
    };

    const headerShimmerStyle = {
        background: 'linear-gradient(90deg, #689fbd 25%, #c0c0c0 50%, #689fbd 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2.5s infinite',
        borderRadius: '4px'
    };

    // Generate random widths for field values
    const generateRandomWidths = () => {
        const widths = ['60%', '70%', '80%', '90%', '65%', '75%', '85%', '55%'];
        return Array.from({ length: fieldCount }, () => {
            return widths[Math.floor(Math.random() * widths.length)];
        });
    };

    const fieldWidths = generateRandomWidths();

    return (
        <div className={`${className}`}>
            {/* Loading indicator */}
            <div className="text-center py-3 text-muted">
                <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <span>Loading profile...</span>
            </div>

            {/* Profile Card Skeleton */}
            <div className="card" style={{minWidth: "550px"}}>
                {/* Card Header */}
                <div className="card-header d-flex justify-content-between">
                    <div>
                        <div style={{
                            ...shimmerStyle,
                            height: '24px',
                            width: '180px'
                        }}></div>
                    </div>
                </div>

                {/* Card Body */}
                <div className="card-body collapse collapse-content show">
                    {/* Profile Image Section */}
                    {showImage && (
                        <div className="text-center d-inline-block align-top p-2"
                             style={{borderRadius: "7px", backgroundColor: "#f9fbfd"}}>
                            <div style={{
                                ...shimmerStyle,
                                width: '150px',
                                height: '150px',
                                borderRadius: '12px',
                                margin: '0 auto'
                            }}></div>
                        </div>
                    )}

                    {/* Form Fields Section */}
                    <form className="d-inline align-top form-control-plaintext">
                        {/* Column 1 */}
                        <div className="mx-5 mt-2 align-top d-inline-block" style={{minWidth: "300px"}}>
                            {Array.from({ length: Math.ceil(fieldCount / 2) }, (_, index) => (
                                <div key={`field-${index}`} className="mt-2 d-flex">
                                    {/* Label */}
                                    <div style={{
                                        ...shimmerStyle,
                                        height: '16px',
                                        width: '75px',
                                        minWidth: '75px'
                                    }}></div>
                                    
                                    {/* Value */}
                                    <div className="ms-4" style={{
                                        ...shimmerStyle,
                                        height: '16px',
                                        width: fieldWidths[index] || '70%'
                                    }}></div>
                                </div>
                            ))}
                        </div>

                        {/* Column 2 */}
                        <div className="mx-5 mt-2 d-inline-block align-top" style={{minWidth: "300px"}}>
                            {Array.from({ length: Math.floor(fieldCount / 2) }, (_, index) => (
                                <div key={`field-col2-${index}`} className="mt-2 d-flex">
                                    {/* Label */}
                                    <div style={{
                                        ...shimmerStyle,
                                        height: '16px',
                                        width: '75px',
                                        minWidth: '75px'
                                    }}></div>
                                    
                                    {/* Value */}
                                    <div className="ms-4" style={{
                                        ...shimmerStyle,
                                        height: '16px',
                                        width: fieldWidths[index + Math.ceil(fieldCount / 2)] || '70%'
                                    }}></div>
                                </div>
                            ))}
                        </div>
                    </form>
                </div>
            </div>

            {/* Shimmer animation CSS */}
            <style>{`
                @keyframes shimmer {
                    0% {
                        background-position: -200% 0;
                    }
                    100% {
                        background-position: 200% 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default ProfileSkeleton;